import { Button } from "@biblioteksentralen/react";
import onDesktop from "../../utils/onDesktop";
import { ComponentProps } from "react";

export const SommerlesButton = (props: ComponentProps<typeof Button>) => {
  return (
    <Button
      background="#4C1433"
      color="#F3CC6A"
      textDecoration="none"
      marginTop={{ base: "0.5rem", md: "unset" }}
      fontSize={{ base: "md", md: "lg" }}
      padding={{ base: "0.25rem 1rem", md: "0.5rem 1rem" }}
      border="2px solid #F3CC6A"
      _hover={{}}
      _groupHover={onDesktop({ filter: "brightness(0.85)" })}
      transition="filter 0.3s ease"
      {...props}
    />
  );
};
